import router from '@/router'
import {
    store
} from '@/store/store'

export function errorHandler(error) {
    if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
            store.dispatch('tryAutoLogin')
            if (store.getters.estaAutenticado) {
                router.push('/naoautorizado')
            } else {
                router.push('/login')
            }
        } else if (error.response.status === 400) {
            let errorData = error.response.data
            if (errorData.exception) {
                store.dispatch('setRequestError', errorData.message)
                router.push('/erro')
            } else {
                return errorData
            }
        } else {
            store.dispatch('setRequestError', error.response)
            router.push('/erro')
        }
    } else if (error.request) {
        store.dispatch('setRequestError', error.request)
        router.push('/erro')
    } else {
        console.log(error.message)
    }
}
